const USER_PHONE_CHECK = 'core/userPhoneCheck/USER_PHONE_CHECK';
const USER_PHONE_CHECK_COMPLETED = 'core/userPhoneCheck/USER_PHONE_CHECK_COMPLETED';
const USER_PHONE_CHECK_FAILED = 'core/userPhoneCheck/USER_PHONE_CHECK_FAILED';

const USER_CHECK_ABLE_MODIFY = 'core/userPhoneCheck/USER_CHECK_ABLE_MODIFY';
const USER_CHECK_ABLE_MODIFY_COMPLETED = 'core/userPhoneCheck/USER_CHECK_ABLE_MODIFY_COMPLETED';
const USER_CHECK_ABLE_MODIFY_FAILED = 'core/userPhoneCheck/USER_CHECK_ABLE_MODIFY_FAILED';

const USER_PHONE_SET_COUNTER = 'core/userPhoneCheck/USER_PHONE_SET_COUNTER';

const USER_PHONE_CHECK_RESET = 'core/userPhoneCheck/USER_PHONE_CHECK_RESET';

export {
  USER_PHONE_CHECK,
  USER_PHONE_CHECK_COMPLETED,
  USER_PHONE_CHECK_FAILED,
  USER_PHONE_SET_COUNTER,
  USER_PHONE_CHECK_RESET,
  USER_CHECK_ABLE_MODIFY,
  USER_CHECK_ABLE_MODIFY_COMPLETED,
  USER_CHECK_ABLE_MODIFY_FAILED
};
